export default {
  chartNetMatchValue: {
    chartTitle: 'NET VALUE BY INVESTOR',
    tooltipIndividual: 'Net Individual Value : {0} Bn.',
    tooltipInstitution: 'Net Local Institution Value : {0} Bn.',
    tooltipProprietary: 'Net Proprietary Value : {0} Bn.',
    tooltipForeign: 'Net Foreign Value : {0} Bn.',
    inforPrice: '{0} : {1} ',
    category: 'Time : {0}',
    legendIndividual: 'Individual',
    legendInstitution: 'Local Institution',
    legendProprietary: 'Proprietary',
    legendForeign: 'Foreign',
    legendCode: 'Price',
    yAxis1Title: 'Billion VND',
    yAxis2Title: 'Price Index',
  },
  listTimeRangeByKey: {
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
  },

  listValueType: {
    MatchValue: 'Match Value',
    TotalValue: 'Total Value',
  },

  heatmap: {
    tooltipBuyTitle: ' Buy Value: ',
    tooltipBuyNetTitle: ' Net Value: ',
    investorBuyNetTitle: ' Net Buy Value: ',
    tooltipSellTitle: ' Sell Value: ',
    tooltipSellNetTitle: ' Net Value: ',
    investorSellNetTitle: ' Net Sell Value: ',
  },

  INDIVIDUAL: 'Individual',
  INSTITUTION: 'Local Institution',
  PROPRIETARY: 'Proprietary',
  FOREIGN: 'Foreign',

  TOTAL_VALUE: 'Total Value',
  NET_TOTAL_VALUE: 'Net Total Value',
  MATCH_VALUE: 'Match Value',
  NET_MATCH_VALUE: 'Net Match Value',
  DEAL_VALUE: 'Deal Value',
  NET_DEAL_VALUE: 'Net Deal Value',
};
